import { useState } from "react";
import Link from "next/link";

const MobileMenu = ({ isToggled, handleToggle, pagesHeader }) => {
  const [pages, setPages] = useState(pagesHeader || []);

  function getCurrentPath(id) {
    const currentPage = pages.find((item) => item.id === id);
    return {
      link: currentPage?.seo_permalink,
      title: currentPage?.title,
    };
  }
 
  return (
    <>
      <div
        className={`${
          isToggled ? "blog" : "hidden"
        } navbar-menu relative z-50 transition duration-300`}
      >
        <div
          className="navbar-backdrop fixed inset-0 bg-pgray-800 opacity-25"
          onClick={handleToggle}
        />
        <nav className="fixed top-0 left-0 bottom-0 flex flex-col w-5/6 max-w-sm py-6 px-6 bg-white border-r overflow-y-auto transition duration-300">
          <div className="flex items-center mb-8 justify-between">
            <Link href="/" className="logo py-1  max-w-[110px] text-center">
              <img
                width={134}
                height={29}
                sizes="50vw"
                src="/images/vieillir-a-la-maison-logo.svg"
                alt="Vieillir à la maison, aide, soins à domicile"
              />
            </Link>
            <button className="navbar-close" onClick={handleToggle}>
              <svg
                className="h-6 w-6 text-pgray-400 cursor-pointer hover:text-primary-1000"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div>
            <ul className="mobile-menu">
              <li className="mb-1 rounded-xl">
                <Link
                  className="block p-3 text-sm text-pgray-500 hover:bg-primary-50/50  hover:text-primary-1000 rounded-xl"
                  href="/"
                >
                  {getCurrentPath(53).title}
                </Link>
              </li>
              <li className="mb-1 rounded-xl">
                <Link
                  className="block p-3 text-sm text-pgray-500 hover:bg-primary-50/50  hover:text-primary-1000 rounded-xl"
                  href={"/"+ getCurrentPath(64).link??""}
                >
                  {getCurrentPath(64).title}
                </Link>
              </li>

              <li className="mb-1 rounded-xl">
                <Link
                  className="block p-3 text-sm text-pgray-500 hover:bg-primary-50/50  hover:text-primary-1000 rounded-xl"
                  href={"/"+ getCurrentPath(66).link??""}
                >
                  {getCurrentPath(66).title}
                </Link>
              </li>
              <li className="mb-1 rounded-xl">
                <Link
                  className="block p-3 text-sm text-pgray-500 hover:bg-primary-50/50  hover:text-primary-1000 rounded-xl"
                  href="#"
                >
                  Emplois
                </Link>
              </li>
              <li className="mb-1 rounded-xl">
                <Link
                  className="block p-3 text-sm text-pgray-500 hover:bg-primary-50/50  hover:text-primary-1000 rounded-xl"
                  href={"/"+ getCurrentPath(61).link??""}
                >
                  {getCurrentPath(61).title}
                </Link>
              </li>
              <li className="mb-1 rounded-xl">
                <Link
                  className="block p-3 text-sm text-pgray-500 hover:bg-primary-50/50  hover:text-primary-1000 rounded-xl"
                  href={"/"+ getCurrentPath(62).link??""}
                >
                  {getCurrentPath(62).title}
                </Link>
              </li>
            </ul>
            <div className="mt-4 pt-6 border-t border-pgray-100">
              <Link
                className="block px-4 py-3 mb-3 text-xs text-center font-semibold leading-none bg-primary-1000 hover:bg-primary-1000   text-white rounded"
                href={"/"+ getCurrentPath(62).link??""}
              >
                Besoin d&apos;aide ?
              </Link>
              <Link
                className="block px-4 py-3 mb-2 text-xs text-center text-primary-1000 hover:text-primary-1000 font-semibold leading-none border border-primary-1000 hover:border-primary-1000 rounded"
                href="#"
              >
                Log In
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default MobileMenu;
